var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2328 0H5.83281C4.78781 0 3.93281 0.855 3.93281 1.9V13.3C3.93281 14.345 4.78781 15.2 5.83281 15.2H17.2328C18.2778 15.2 19.1328 14.345 19.1328 13.3V1.9C19.1328 0.855 18.2778 0 17.2328 0ZM9.15781 7.125C9.15781 7.9135 8.52131 8.55 7.73281 8.55H6.78281V10.45H5.35781V4.75H7.73281C8.52131 4.75 9.15781 5.3865 9.15781 6.175V7.125ZM13.9078 9.025C13.9078 9.8135 13.2713 10.45 12.4828 10.45H10.1078V4.75H12.4828C13.2713 4.75 13.9078 5.3865 13.9078 6.175V9.025ZM17.7078 6.175H16.2828V7.125H17.7078V8.55H16.2828V10.45H14.8578V4.75H17.7078V6.175ZM6.78281 7.125H7.73281V6.175H6.78281V7.125ZM2.03281 3.8H0.132812V17.1C0.132812 18.145 0.987812 19 2.03281 19H15.3328V17.1H2.03281V3.8ZM11.5328 9.025H12.4828V6.175H11.5328V9.025Z",
    fill: "#26A677"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf-icon.4ad2302f1de90db26e0db5af4e6eaed6.svg";
export { ForwardRef as ReactComponent };